<!-- Project Selection — full-screen overlay above nav (z-50 > nav z-40) -->
<div class="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 overflow-hidden p-4">

  <!-- Sign out (top-right) -->
  <button
    type="button"
    (click)="signOut()"
    title="Sign out"
    class="absolute top-4 right-4 z-[60] inline-flex items-center gap-1.5 rounded-lg border border-gray-700/60 bg-gray-800/70 px-3 py-1.5 text-xs font-medium text-gray-300 hover:text-white hover:border-gray-600 hover:bg-gray-700/70 transition-all duration-200">
    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <polyline points="16 17 21 12 16 7" />
      <line x1="21" y1="12" x2="9" y2="12" />
    </svg>
    Sign out
  </button>

  <!-- Honeycomb background -->
  <div class="hex-grid">
    <div *ngFor="let row of hexRows; let r = index"
         class="hex-row"
         [style.transform]="hexRowOffset(r)">
      <div *ngFor="let col of row; let c = index" class="shrink-0">
        <svg xmlns="http://www.w3.org/2000/svg" width="108" height="122" viewBox="0 0 108 122" fill="none">
          <path
            [attr.data-hex]="r + '-' + c"
            d="M49.9557 1.3094C52.431 -0.119663 55.4805 -0.119661 57.9557 1.3094L103.659 27.6961C106.134 29.1252 107.659 32.1312 107.659 34.6243V87.398C107.659 89.8911 106.134 92.897 103.659 94.3261L57.9557 120.713C55.4805 122.142 52.431 122.142 49.9557 120.713L4.252 94.3261C1.77679 92.897 0.252014 89.8911 0.252014 87.398V34.6243C0.252014 32.1312 1.7768 29.1252 4.252 27.6961L49.9557 1.3094Z"
            stroke="transparent"
            stroke-width="1.5"
            class="hex-cell"
          />
        </svg>
      </div>
    </div>
  </div>

  <!-- Feature SVGs — hidden on small screens -->
  <div class="hidden lg:block absolute inset-0 pointer-events-none">

    <!-- Spotlight — top-left: mini dashboard + drifting lens -->
    <div class="feature-container feature-container-1 absolute top-[14%] left-[8%]">
      <svg width="310" height="233" viewBox="0 0 195 150" fill="none" xmlns="http://www.w3.org/2000/svg">

        <!-- Dashboard frame with white bg -->
        <rect x="3" y="3" width="189" height="144" rx="6" fill="rgba(255,255,255,0.06)" stroke="rgba(255,255,255,0.12)" stroke-width="1" />

        <!-- Top bar -->
        <rect x="3" y="3" width="189" height="18" rx="6" fill="rgba(255,255,255,0.04)" />
        <circle cx="14" cy="12" r="2.5" fill="rgba(239,68,68,0.5)" />
        <circle cx="23" cy="12" r="2.5" fill="rgba(234,179,8,0.5)" />
        <circle cx="32" cy="12" r="2.5" fill="rgba(34,197,94,0.5)" />
        <text x="97" y="15.5" text-anchor="middle" font-size="9" font-weight="900" letter-spacing="2.5" fill="rgba(168,85,247,0.7)" font-family="system-ui, sans-serif">SPOTLIGHT</text>

        <!-- Sidebar -->
        <line x1="42" y1="21" x2="42" y2="147" stroke="rgba(255,255,255,0.06)" stroke-width="1" />
        <rect x="11" y="30" width="22" height="3" rx="1.5" fill="rgba(168,85,247,0.4)" />
        <rect x="11" y="40" width="18" height="3" rx="1.5" fill="rgba(255,255,255,0.12)" />
        <rect x="11" y="50" width="20" height="3" rx="1.5" fill="rgba(255,255,255,0.12)" />
        <rect x="11" y="60" width="15" height="3" rx="1.5" fill="rgba(255,255,255,0.12)" />
        <rect x="11" y="70" width="20" height="3" rx="1.5" fill="rgba(255,255,255,0.12)" />
        <rect x="11" y="80" width="16" height="3" rx="1.5" fill="rgba(255,255,255,0.08)" />

        <!-- Bar chart card -->
        <rect x="50" y="28" width="62" height="48" rx="3" fill="rgba(255,255,255,0.04)" stroke="rgba(255,255,255,0.06)" stroke-width="0.5" />
        <rect x="55" y="32" width="24" height="2.5" rx="1" fill="rgba(255,255,255,0.15)" />
        <rect x="58" y="58" width="6" height="12" rx="1" fill="rgba(168,85,247,0.35)" />
        <rect x="68" y="50" width="6" height="20" rx="1" fill="rgba(99,102,241,0.45)" />
        <rect x="78" y="42" width="6" height="28" rx="1" fill="rgba(168,85,247,0.55)" />
        <rect x="88" y="48" width="6" height="22" rx="1" fill="rgba(249,115,22,0.45)" />
        <rect x="98" y="54" width="6" height="16" rx="1" fill="rgba(168,85,247,0.3)" />
        <line x1="55" y1="70" x2="107" y2="70" stroke="rgba(255,255,255,0.08)" stroke-width="0.5" />

        <!-- Stats card -->
        <rect x="120" y="28" width="64" height="48" rx="3" fill="rgba(255,255,255,0.04)" stroke="rgba(255,255,255,0.06)" stroke-width="0.5" />
        <rect x="127" y="33" width="26" height="2.5" rx="1" fill="rgba(255,255,255,0.15)" />
        <rect x="127" y="41" width="16" height="7" rx="1.5" fill="rgba(249,115,22,0.3)" />
        <rect x="148" y="41" width="16" height="7" rx="1.5" fill="rgba(168,85,247,0.3)" />
        <!-- Line graph -->
        <polyline points="127,62 136,57 144,60 152,52 160,55 168,48 176,50" stroke="rgba(34,197,94,0.5)" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" fill="none" />
        <polyline points="127,66 136,64 144,67 152,61 160,63 168,58 176,56" stroke="rgba(99,102,241,0.3)" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" fill="none" />

        <!-- Table card -->
        <rect x="50" y="83" width="134" height="56" rx="3" fill="rgba(255,255,255,0.04)" stroke="rgba(255,255,255,0.06)" stroke-width="0.5" />
        <!-- Table header -->
        <line x1="50" y1="94" x2="184" y2="94" stroke="rgba(255,255,255,0.08)" stroke-width="0.5" />
        <rect x="56" y="88" width="20" height="2.5" rx="1" fill="rgba(255,255,255,0.2)" />
        <rect x="86" y="88" width="20" height="2.5" rx="1" fill="rgba(255,255,255,0.2)" />
        <rect x="116" y="88" width="20" height="2.5" rx="1" fill="rgba(255,255,255,0.2)" />
        <rect x="146" y="88" width="20" height="2.5" rx="1" fill="rgba(255,255,255,0.2)" />
        <!-- Row 1 -->
        <rect x="56" y="100" width="18" height="2" rx="1" fill="rgba(255,255,255,0.06)" />
        <rect x="86" y="100" width="14" height="2" rx="1" fill="rgba(255,255,255,0.06)" />
        <rect x="116" y="100" width="16" height="2" rx="1" fill="rgba(168,85,247,0.25)" />
        <rect x="146" y="100" width="12" height="2" rx="1" fill="rgba(255,255,255,0.06)" />
        <!-- Row 2 -->
        <line x1="50" y1="108" x2="184" y2="108" stroke="rgba(255,255,255,0.04)" stroke-width="0.5" />
        <rect x="56" y="113" width="16" height="2" rx="1" fill="rgba(255,255,255,0.06)" />
        <rect x="86" y="113" width="18" height="2" rx="1" fill="rgba(255,255,255,0.06)" />
        <rect x="116" y="113" width="12" height="2" rx="1" fill="rgba(249,115,22,0.25)" />
        <rect x="146" y="113" width="14" height="2" rx="1" fill="rgba(255,255,255,0.06)" />
        <!-- Row 3 -->
        <line x1="50" y1="121" x2="184" y2="121" stroke="rgba(255,255,255,0.04)" stroke-width="0.5" />
        <rect x="56" y="126" width="20" height="2" rx="1" fill="rgba(255,255,255,0.06)" />
        <rect x="86" y="126" width="12" height="2" rx="1" fill="rgba(255,255,255,0.06)" />
        <rect x="116" y="126" width="18" height="2" rx="1" fill="rgba(168,85,247,0.25)" />
        <rect x="146" y="126" width="10" height="2" rx="1" fill="rgba(255,255,255,0.06)" />
        <!-- Row 4 -->
        <line x1="50" y1="133" x2="184" y2="133" stroke="rgba(255,255,255,0.04)" stroke-width="0.5" />

        <!-- Lens — drifts over the dashboard -->
        <g class="lens-group">
          <circle cx="40" cy="35" r="13" stroke="rgba(168,85,247,0.7)" stroke-width="1.5" fill="rgba(168,85,247,0.05)" />
          <line x1="49" y1="44" x2="58" y2="53" stroke="rgba(168,85,247,0.7)" stroke-width="2" stroke-linecap="round" />
        </g>
      </svg>
    </div>

    <!-- Forge — right: Blockly blocks → code output -->
    <div class="feature-container feature-container-2 absolute top-[14%] right-[4%]">
      <svg width="390" height="440" viewBox="0 -8 280 290" fill="none" xmlns="http://www.w3.org/2000/svg">

        <!-- FORGE header -->
        <rect x="3" y="-5" width="60" height="19" rx="4" fill="rgba(249,115,22,0.1)" stroke="rgba(249,115,22,0.25)" stroke-width="0.5" />
        <text x="33" y="8" text-anchor="middle" font-size="11" font-weight="900" letter-spacing="3" fill="rgba(249,115,22,0.7)" font-family="system-ui, sans-serif">FORGE</text>

        <!-- ═══ BLOCK STACK (left, x=3..98) ═══ -->
        <g class="forge-block-glow">

        <!-- Block 1: Import (swaps down) -->
        <g class="forge-swap-down-a">
        <rect x="3" y="20" width="95" height="20" rx="3" fill="rgba(249,115,22,0.15)" stroke="rgba(249,115,22,0.4)" stroke-width="1" />
        <rect x="14" y="17" width="10" height="3" rx="1" fill="rgba(249,115,22,0.25)" />
        <path d="M10 27 L7 30 L10 33" stroke="rgba(249,115,22,0.5)" stroke-width="0.8" fill="none" stroke-linecap="round" />
        <path d="M16 27 L19 30 L16 33" stroke="rgba(249,115,22,0.5)" stroke-width="0.8" fill="none" stroke-linecap="round" />
        <rect x="23" y="27" width="22" height="2.5" rx="1" fill="rgba(255,255,255,0.15)" />
        <rect x="49" y="27" width="16" height="2.5" rx="1" fill="rgba(168,85,247,0.3)" />
        <rect x="69" y="27" width="20" height="2.5" rx="1" fill="rgba(255,255,255,0.08)" />
        <rect x="14" y="40" width="10" height="3" rx="1" fill="rgba(249,115,22,0.25)" />
        </g>

        <!-- Block 2: Set Variable (swaps up) -->
        <g class="forge-swap-up-a">
        <rect x="3" y="43" width="95" height="20" rx="3" fill="rgba(249,115,22,0.15)" stroke="rgba(249,115,22,0.4)" stroke-width="1" />
        <rect x="14" y="43" width="10" height="3" rx="1" fill="rgba(249,115,22,0.25)" />
        <circle cx="12" cy="53" r="3" stroke="rgba(249,115,22,0.4)" stroke-width="0.8" fill="rgba(249,115,22,0.1)" />
        <rect x="19" y="50" width="24" height="2.5" rx="1" fill="rgba(255,255,255,0.15)" />
        <rect x="47" y="50" width="14" height="2.5" rx="1" fill="rgba(249,115,22,0.3)" />
        <rect x="65" y="50" width="22" height="2.5" rx="1" fill="rgba(255,255,255,0.08)" />
        <rect x="14" y="63" width="10" height="3" rx="1" fill="rgba(249,115,22,0.25)" />
        </g>

        <!-- forEach jitter group -->
        <g class="forge-shuffle-b">
        <!-- Block 3: purple "forEach" C-block -->
        <path d="M3 66 H95 Q98 66 98 69 V79 H20 V121 H98 V125 Q98 128 95 128 H3 Q0 128 0 125 V69 Q0 66 3 66 Z" fill="rgba(168,85,247,0.12)" stroke="rgba(168,85,247,0.35)" stroke-width="1" />
        <rect x="14" y="66" width="10" height="3" rx="1" fill="rgba(168,85,247,0.25)" />
        <path d="M10 72 A3 3 0 1 1 10 78 M10 78 L14 75" stroke="rgba(168,85,247,0.5)" stroke-width="0.8" fill="none" stroke-linecap="round" />
        <rect x="20" y="71" width="18" height="2.5" rx="1" fill="rgba(255,255,255,0.15)" />
        <rect x="42" y="71" width="12" height="2.5" rx="1" fill="rgba(249,115,22,0.25)" />
        <rect x="58" y="71" width="8" height="2.5" rx="1" fill="rgba(255,255,255,0.1)" />
        <rect x="70" y="71" width="16" height="2.5" rx="1" fill="rgba(168,85,247,0.2)" />

        <!-- Block 3a: nested orange "Filter" -->
        <rect x="20" y="82" width="75" height="18" rx="3" fill="rgba(249,115,22,0.12)" stroke="rgba(249,115,22,0.3)" stroke-width="0.8" />
        <rect x="30" y="79" width="10" height="3" rx="1" fill="rgba(249,115,22,0.2)" />
        <path d="M27 87 L31 87 L30 90 L28 90 Z" fill="rgba(249,115,22,0.35)" />
        <rect x="35" y="88" width="18" height="2.5" rx="1" fill="rgba(255,255,255,0.12)" />
        <rect x="57" y="88" width="10" height="2.5" rx="1" fill="rgba(168,85,247,0.25)" />
        <rect x="71" y="88" width="16" height="2.5" rx="1" fill="rgba(255,255,255,0.08)" />
        <rect x="30" y="100" width="10" height="3" rx="1" fill="rgba(249,115,22,0.2)" />

        <!-- Block 3b: nested orange "Update" -->
        <rect x="20" y="103" width="75" height="18" rx="3" fill="rgba(249,115,22,0.12)" stroke="rgba(249,115,22,0.3)" stroke-width="0.8" />
        <rect x="30" y="103" width="10" height="3" rx="1" fill="rgba(249,115,22,0.2)" />
        <path d="M26 110 L30 106 L32 108 L28 112 Z" fill="rgba(249,115,22,0.3)" />
        <rect x="35" y="109" width="14" height="2.5" rx="1" fill="rgba(255,255,255,0.12)" />
        <rect x="53" y="109" width="16" height="2.5" rx="1" fill="rgba(249,115,22,0.2)" />
        <rect x="73" y="109" width="14" height="2.5" rx="1" fill="rgba(255,255,255,0.08)" />

        <!-- forEach footer -->
        <rect x="8" y="123" width="14" height="2.5" rx="1" fill="rgba(168,85,247,0.2)" />
        <rect x="26" y="123" width="20" height="2.5" rx="1" fill="rgba(255,255,255,0.1)" />
        <rect x="14" y="128" width="10" height="3" rx="1" fill="rgba(168,85,247,0.25)" />
        </g>

        <!-- Block 4: If C-block (fast shuffle) -->
        <g class="forge-shuffle-if">
        <path d="M3 131 H95 Q98 131 98 134 V144 H20 V169 H98 V173 Q98 176 95 176 H3 Q0 176 0 173 V134 Q0 131 3 131 Z" fill="rgba(168,85,247,0.12)" stroke="rgba(168,85,247,0.35)" stroke-width="1" />
        <rect x="14" y="131" width="10" height="3" rx="1" fill="rgba(168,85,247,0.25)" />
        <rect x="8" y="135" width="8" height="5" rx="1.5" fill="rgba(168,85,247,0.3)" />
        <rect x="20" y="136" width="20" height="2.5" rx="1" fill="rgba(255,255,255,0.15)" />
        <rect x="44" y="136" width="12" height="2.5" rx="1" fill="rgba(249,115,22,0.25)" />
        <rect x="60" y="136" width="8" height="2.5" rx="1" fill="rgba(255,255,255,0.1)" />
        <rect x="72" y="136" width="16" height="2.5" rx="1" fill="rgba(168,85,247,0.2)" />

        <!-- Block 4a: nested orange "Emit" -->
        <rect x="20" y="147" width="75" height="18" rx="3" fill="rgba(249,115,22,0.12)" stroke="rgba(249,115,22,0.3)" stroke-width="0.8" />
        <rect x="30" y="144" width="10" height="3" rx="1" fill="rgba(249,115,22,0.2)" />
        <path d="M27 156 L29 153 L31 156" stroke="rgba(249,115,22,0.35)" stroke-width="0.7" fill="none" stroke-linecap="round" />
        <circle cx="29" cy="153" r="1" fill="rgba(249,115,22,0.3)" />
        <rect x="35" y="153" width="16" height="2.5" rx="1" fill="rgba(255,255,255,0.12)" />
        <rect x="55" y="153" width="22" height="2.5" rx="1" fill="rgba(249,115,22,0.2)" />

        <!-- If footer -->
        <rect x="8" y="171" width="14" height="2.5" rx="1" fill="rgba(168,85,247,0.2)" />
        <rect x="26" y="171" width="20" height="2.5" rx="1" fill="rgba(255,255,255,0.1)" />
        <rect x="14" y="176" width="10" height="3" rx="1" fill="rgba(168,85,247,0.25)" />
        </g>

        <!-- Block 5: Log (swaps down) -->
        <g class="forge-swap-down-b">
        <rect x="3" y="179" width="95" height="20" rx="3" fill="rgba(249,115,22,0.15)" stroke="rgba(249,115,22,0.4)" stroke-width="1" />
        <rect x="14" y="179" width="10" height="3" rx="1" fill="rgba(249,115,22,0.25)" />
        <rect x="8" y="186" width="6" height="5" rx="1" fill="rgba(249,115,22,0.2)" stroke="rgba(249,115,22,0.35)" stroke-width="0.5" />
        <rect x="19" y="186" width="20" height="2.5" rx="1" fill="rgba(255,255,255,0.15)" />
        <rect x="43" y="186" width="18" height="2.5" rx="1" fill="rgba(249,115,22,0.3)" />
        <rect x="65" y="186" width="24" height="2.5" rx="1" fill="rgba(255,255,255,0.08)" />
        <rect x="14" y="199" width="10" height="3" rx="1" fill="rgba(249,115,22,0.25)" />
        </g>

        <!-- Block 6: Validate (swaps up) -->
        <g class="forge-swap-up-b">
        <rect x="3" y="202" width="95" height="20" rx="3" fill="rgba(168,85,247,0.12)" stroke="rgba(168,85,247,0.35)" stroke-width="1" />
        <rect x="14" y="202" width="10" height="3" rx="1" fill="rgba(168,85,247,0.25)" />
        <path d="M9 212 L12 215 L17 208" stroke="rgba(168,85,247,0.5)" stroke-width="1" fill="none" stroke-linecap="round" stroke-linejoin="round" />
        <rect x="21" y="209" width="22" height="2.5" rx="1" fill="rgba(255,255,255,0.15)" />
        <rect x="47" y="209" width="16" height="2.5" rx="1" fill="rgba(168,85,247,0.3)" />
        <rect x="67" y="209" width="20" height="2.5" rx="1" fill="rgba(255,255,255,0.08)" />
        <rect x="14" y="222" width="10" height="3" rx="1" fill="rgba(168,85,247,0.25)" />
        </g>

        <!-- Block 7: orange "Return" -->
        <g class="forge-shuffle-ret">
        <rect x="3" y="225" width="95" height="20" rx="3" fill="rgba(249,115,22,0.15)" stroke="rgba(249,115,22,0.4)" stroke-width="1" />
        <rect x="14" y="225" width="10" height="3" rx="1" fill="rgba(249,115,22,0.25)" />
        <path d="M10 235 L16 235 L13 231 Z" fill="rgba(249,115,22,0.4)" />
        <rect x="19" y="232" width="18" height="2.5" rx="1" fill="rgba(255,255,255,0.15)" />
        <rect x="41" y="232" width="22" height="2.5" rx="1" fill="rgba(249,115,22,0.25)" />
        <rect x="67" y="232" width="20" height="2.5" rx="1" fill="rgba(255,255,255,0.08)" />
        </g>

        </g>

        <!-- ═══ DRAGGING BLOCK + CURSOR (animated) ═══ -->
        <g class="forge-drag" style="transform-origin: 57px 91px;">
          <rect x="20" y="82" width="75" height="18" rx="3" fill="rgba(249,115,22,0.2)" stroke="rgba(249,115,22,0.5)" stroke-width="1" />
          <rect x="30" y="79" width="10" height="3" rx="1" fill="rgba(249,115,22,0.3)" />
          <rect x="35" y="88" width="18" height="2.5" rx="1" fill="rgba(255,255,255,0.18)" />
          <rect x="57" y="88" width="12" height="2.5" rx="1" fill="rgba(168,85,247,0.35)" />
          <rect x="73" y="88" width="14" height="2.5" rx="1" fill="rgba(255,255,255,0.1)" />
        </g>

        <!-- Drag cursor (hand) -->
        <g class="forge-cursor" style="transform-origin: 85px 100px;">
          <rect x="82" y="93" width="4" height="7.5" rx="2" fill="rgba(255,255,255,0.85)" stroke="rgba(0,0,0,0.2)" stroke-width="0.4" />
          <rect x="80" y="99" width="9.5" height="7" rx="2.5" fill="rgba(255,255,255,0.85)" stroke="rgba(0,0,0,0.2)" stroke-width="0.4" />
          <ellipse cx="79.5" cy="101" rx="2" ry="1.2" transform="rotate(-35, 79.5, 101)" fill="rgba(255,255,255,0.8)" stroke="rgba(0,0,0,0.15)" stroke-width="0.3" />
        </g>

        <!-- Snap flash when block lands -->
        <rect x="16" y="78" width="83" height="26" rx="4" fill="rgba(249,115,22,0.4)" class="forge-snap" style="opacity:0" />

        <!-- ═══ ARROW (center, pulsing) ═══ -->
        <g class="forge-arrow">
        <line x1="108" y1="140" x2="138" y2="140" stroke="rgba(255,255,255,0.2)" stroke-width="1.5" stroke-linecap="round" />
        <path d="M136 136 L142 140 L136 144" stroke="rgba(255,255,255,0.25)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none" />
        </g>
        <!-- Floating sparkles -->
        <circle cx="115" cy="134" r="1" fill="rgba(249,115,22,0.3)" class="forge-sparkle" />
        <circle cx="130" cy="146" r="0.8" fill="rgba(168,85,247,0.3)" class="forge-sparkle" style="animation-delay: 1s;" />
        <circle cx="112" cy="145" r="0.6" fill="rgba(249,115,22,0.2)" class="forge-sparkle" style="animation-delay: 2.5s;" />
        <circle cx="135" cy="133" r="0.7" fill="rgba(168,85,247,0.25)" class="forge-sparkle" style="animation-delay: 4s;" />
        <circle cx="120" cy="148" r="0.5" fill="rgba(249,115,22,0.15)" class="forge-sparkle" style="animation-delay: 5.5s;" />
        <circle cx="125" cy="130" r="0.6" fill="rgba(168,85,247,0.2)" class="forge-sparkle" style="animation-delay: 3s;" />

        <!-- ═══ CODE OUTPUT (right) ═══ -->
        <rect x="150" y="20" width="125" height="260" rx="5" fill="rgba(255,255,255,0.06)" stroke="rgba(255,255,255,0.1)" stroke-width="1" />

        <!-- Code panel header -->
        <rect x="150" y="20" width="125" height="14" rx="5" fill="rgba(255,255,255,0.04)" />
        <circle cx="158" cy="27" r="1.8" fill="rgba(239,68,68,0.4)" />
        <circle cx="165" cy="27" r="1.8" fill="rgba(234,179,8,0.4)" />
        <circle cx="172" cy="27" r="1.8" fill="rgba(34,197,94,0.4)" />
        <rect x="195" y="25" width="30" height="3" rx="1.5" fill="rgba(255,255,255,0.06)" />
        <rect x="230" y="25" width="20" height="3" rx="1.5" fill="rgba(249,115,22,0.1)" />

        <!-- Line numbers gutter -->
        <line x1="156" y1="38" x2="156" y2="274" stroke="rgba(255,255,255,0.05)" stroke-width="0.5" />

        <!-- Imports -->
        <g class="forge-type" style="animation-delay: 0s;">
        <rect x="159" y="42" width="16" height="2.5" rx="1" fill="rgba(168,85,247,0.4)" />
        <rect x="178" y="42" width="8" height="2.5" rx="1" fill="rgba(255,255,255,0.12)" />
        <rect x="189" y="42" width="16" height="2.5" rx="1" fill="rgba(255,255,255,0.08)" />
        <rect x="208" y="42" width="14" height="2.5" rx="1" fill="rgba(168,85,247,0.3)" />
        <rect x="225" y="42" width="24" height="2.5" rx="1" fill="rgba(249,115,22,0.25)" />
        </g>
        <g class="forge-type" style="animation-delay: 0.42s;">
        <rect x="159" y="50" width="16" height="2.5" rx="1" fill="rgba(168,85,247,0.35)" />
        <rect x="178" y="50" width="8" height="2.5" rx="1" fill="rgba(255,255,255,0.1)" />
        <rect x="189" y="50" width="20" height="2.5" rx="1" fill="rgba(255,255,255,0.08)" />
        <rect x="212" y="50" width="18" height="2.5" rx="1" fill="rgba(249,115,22,0.2)" />
        </g>
        <g class="forge-type" style="animation-delay: 0.84s;">
        <rect x="159" y="58" width="16" height="2.5" rx="1" fill="rgba(168,85,247,0.3)" />
        <rect x="178" y="58" width="8" height="2.5" rx="1" fill="rgba(255,255,255,0.08)" />
        <rect x="189" y="58" width="14" height="2.5" rx="1" fill="rgba(255,255,255,0.06)" />
        <rect x="206" y="58" width="22" height="2.5" rx="1" fill="rgba(249,115,22,0.18)" />
        </g>

        <!-- function -->
        <g class="forge-type" style="animation-delay: 1.26s;">
        <rect x="159" y="72" width="18" height="2.5" rx="1" fill="rgba(168,85,247,0.4)" />
        <rect x="180" y="72" width="24" height="2.5" rx="1" fill="rgba(249,115,22,0.35)" />
        <rect x="207" y="72" width="6" height="2.5" rx="1" fill="rgba(255,255,255,0.15)" />
        <rect x="216" y="72" width="14" height="2.5" rx="1" fill="rgba(255,255,255,0.08)" />
        <rect x="233" y="72" width="4" height="2.5" rx="1" fill="rgba(255,255,255,0.15)" />
        </g>

        <!-- let -->
        <g class="forge-type" style="animation-delay: 1.68s;">
        <rect x="165" y="82" width="10" height="2.5" rx="1" fill="rgba(168,85,247,0.3)" />
        <rect x="178" y="82" width="16" height="2.5" rx="1" fill="rgba(255,255,255,0.12)" />
        <rect x="197" y="82" width="6" height="2.5" rx="1" fill="rgba(255,255,255,0.08)" />
        <rect x="206" y="82" width="20" height="2.5" rx="1" fill="rgba(249,115,22,0.25)" />
        </g>

        <!-- for...of -->
        <g class="forge-type" style="animation-delay: 2.1s;">
        <rect x="165" y="96" width="10" height="2.5" rx="1" fill="rgba(168,85,247,0.35)" />
        <rect x="178" y="96" width="6" height="2.5" rx="1" fill="rgba(255,255,255,0.08)" />
        <rect x="187" y="96" width="14" height="2.5" rx="1" fill="rgba(255,255,255,0.12)" />
        <rect x="204" y="96" width="8" height="2.5" rx="1" fill="rgba(168,85,247,0.25)" />
        <rect x="215" y="96" width="16" height="2.5" rx="1" fill="rgba(255,255,255,0.1)" />
        <rect x="234" y="96" width="4" height="2.5" rx="1" fill="rgba(255,255,255,0.15)" />
        </g>

        <!-- filter + update -->
        <g class="forge-type" style="animation-delay: 2.52s;">
        <rect x="171" y="106" width="8" height="2.5" rx="1" fill="rgba(168,85,247,0.3)" />
        <rect x="182" y="106" width="6" height="2.5" rx="1" fill="rgba(255,255,255,0.08)" />
        <rect x="191" y="106" width="18" height="2.5" rx="1" fill="rgba(255,255,255,0.12)" />
        <rect x="212" y="106" width="22" height="2.5" rx="1" fill="rgba(249,115,22,0.2)" />
        </g>
        <g class="forge-type" style="animation-delay: 2.94s;">
        <rect x="171" y="116" width="14" height="2.5" rx="1" fill="rgba(255,255,255,0.1)" />
        <rect x="188" y="116" width="6" height="2.5" rx="1" fill="rgba(255,255,255,0.06)" />
        <rect x="197" y="116" width="24" height="2.5" rx="1" fill="rgba(249,115,22,0.2)" />
        </g>

        <!-- } -->
        <g class="forge-type" style="animation-delay: 3.36s;">
        <rect x="165" y="126" width="4" height="2.5" rx="1" fill="rgba(255,255,255,0.1)" />
        </g>

        <!-- if + emit + } -->
        <g class="forge-type" style="animation-delay: 3.78s;">
        <rect x="165" y="140" width="8" height="2.5" rx="1" fill="rgba(168,85,247,0.35)" />
        <rect x="176" y="140" width="6" height="2.5" rx="1" fill="rgba(255,255,255,0.08)" />
        <rect x="185" y="140" width="14" height="2.5" rx="1" fill="rgba(255,255,255,0.12)" />
        <rect x="202" y="140" width="6" height="2.5" rx="1" fill="rgba(255,255,255,0.08)" />
        <rect x="211" y="140" width="4" height="2.5" rx="1" fill="rgba(255,255,255,0.15)" />
        </g>
        <g class="forge-type" style="animation-delay: 4.2s;">
        <rect x="171" y="150" width="12" height="2.5" rx="1" fill="rgba(255,255,255,0.1)" />
        <rect x="186" y="150" width="6" height="2.5" rx="1" fill="rgba(255,255,255,0.06)" />
        <rect x="195" y="150" width="28" height="2.5" rx="1" fill="rgba(249,115,22,0.2)" />
        <rect x="226" y="150" width="14" height="2.5" rx="1" fill="rgba(255,255,255,0.08)" />
        </g>
        <g class="forge-type" style="animation-delay: 4.62s;">
        <rect x="165" y="160" width="4" height="2.5" rx="1" fill="rgba(255,255,255,0.1)" />
        </g>

        <!-- console.log -->
        <g class="forge-type" style="animation-delay: 5.04s;">
        <rect x="165" y="174" width="22" height="2.5" rx="1" fill="rgba(255,255,255,0.12)" />
        <rect x="190" y="174" width="6" height="2.5" rx="1" fill="rgba(255,255,255,0.06)" />
        <rect x="199" y="174" width="30" height="2.5" rx="1" fill="rgba(249,115,22,0.2)" />
        <rect x="232" y="174" width="8" height="2.5" rx="1" fill="rgba(255,255,255,0.08)" />
        </g>

        <!-- validate + throw -->
        <g class="forge-type" style="animation-delay: 5.46s;">
        <rect x="165" y="188" width="10" height="2.5" rx="1" fill="rgba(168,85,247,0.3)" />
        <rect x="178" y="188" width="6" height="2.5" rx="1" fill="rgba(255,255,255,0.08)" />
        <rect x="187" y="188" width="20" height="2.5" rx="1" fill="rgba(255,255,255,0.12)" />
        <rect x="210" y="188" width="16" height="2.5" rx="1" fill="rgba(249,115,22,0.2)" />
        <rect x="229" y="188" width="8" height="2.5" rx="1" fill="rgba(255,255,255,0.06)" />
        </g>
        <g class="forge-type" style="animation-delay: 5.88s;">
        <rect x="171" y="198" width="14" height="2.5" rx="1" fill="rgba(168,85,247,0.25)" />
        <rect x="188" y="198" width="8" height="2.5" rx="1" fill="rgba(255,255,255,0.08)" />
        <rect x="199" y="198" width="26" height="2.5" rx="1" fill="rgba(249,115,22,0.18)" />
        </g>

        <!-- return -->
        <g class="forge-type" style="animation-delay: 6.3s;">
        <rect x="165" y="212" width="14" height="2.5" rx="1" fill="rgba(168,85,247,0.3)" />
        <rect x="182" y="212" width="20" height="2.5" rx="1" fill="rgba(255,255,255,0.12)" />
        </g>

        <!-- } + export + module -->
        <g class="forge-type" style="animation-delay: 6.72s;">
        <rect x="159" y="222" width="4" height="2.5" rx="1" fill="rgba(255,255,255,0.1)" />
        </g>
        <g class="forge-type" style="animation-delay: 7.14s;">
        <rect x="159" y="236" width="16" height="2.5" rx="1" fill="rgba(168,85,247,0.3)" />
        <rect x="178" y="236" width="20" height="2.5" rx="1" fill="rgba(255,255,255,0.1)" />
        <rect x="201" y="236" width="24" height="2.5" rx="1" fill="rgba(249,115,22,0.2)" />
        </g>
        <g class="forge-type" style="animation-delay: 7.56s;">
        <rect x="159" y="246" width="24" height="2.5" rx="1" fill="rgba(255,255,255,0.08)" />
        <rect x="186" y="246" width="6" height="2.5" rx="1" fill="rgba(255,255,255,0.06)" />
        <rect x="195" y="246" width="20" height="2.5" rx="1" fill="rgba(249,115,22,0.15)" />
        </g>
        <g class="forge-type" style="animation-delay: 8.0s;">
        <rect x="159" y="256" width="2" height="2.5" rx="1" fill="rgba(255,255,255,0.04)" />
        </g>

        <!-- Code highlight sweep bar -->
        <rect x="152" y="38" width="121" height="8" rx="2" fill="rgba(249,115,22,0.15)" class="forge-code-sweep" style="opacity:0" />

      </svg>
    </div>

    <!-- Atlas — bottom-left: Miller Columns with animated cursor -->
    <div class="feature-container feature-container-3 absolute bottom-[22%] left-[8%]">
      <svg width="290" height="265" viewBox="0 -8 200 195" fill="none" xmlns="http://www.w3.org/2000/svg">

        <!-- Floating header -->
        <rect x="3" y="-5" width="70" height="19" rx="4" fill="rgba(168,85,247,0.1)" stroke="rgba(168,85,247,0.25)" stroke-width="0.5" />
        <text x="38" y="8" text-anchor="middle" font-size="11" font-weight="900" letter-spacing="3" fill="rgba(168,85,247,0.7)" font-family="system-ui, sans-serif">ATLAS</text>

        <!-- All columns wrapped in a group shifted down for the header -->
        <g transform="translate(0,15)">

        <!-- ═══ BASE: column frames + headers + neutral rows ═══ -->

        <!-- Column 1 frame (top level) -->
        <rect x="3" y="3" width="60" height="135" rx="4" fill="rgba(255,255,255,0.06)" stroke="rgba(168,85,247,0.3)" stroke-width="1" />
        <rect x="3" y="3" width="60" height="16" rx="4" fill="rgba(168,85,247,0.12)" />
        <rect x="9" y="9" width="28" height="3" rx="1.5" fill="rgba(168,85,247,0.5)" />

        <!-- Col 1 neutral rows -->
        <rect x="9" y="29" width="14" height="2.5" rx="1" fill="rgba(255,255,255,0.06)" />
        <rect x="26" y="29" width="8" height="2.5" rx="1" fill="rgba(99,102,241,0.15)" />
        <rect x="9" y="44" width="18" height="2.5" rx="1" fill="rgba(255,255,255,0.06)" />
        <rect x="30" y="44" width="10" height="2.5" rx="1" fill="rgba(99,102,241,0.15)" />
        <rect x="9" y="59" width="16" height="2.5" rx="1" fill="rgba(255,255,255,0.06)" />
        <rect x="28" y="59" width="6" height="2.5" rx="1" fill="rgba(99,102,241,0.15)" />
        <rect x="9" y="74" width="12" height="2.5" rx="1" fill="rgba(255,255,255,0.06)" />
        <rect x="24" y="74" width="10" height="2.5" rx="1" fill="rgba(99,102,241,0.15)" />
        <rect x="9" y="89" width="20" height="2.5" rx="1" fill="rgba(255,255,255,0.06)" />
        <rect x="9" y="104" width="14" height="2.5" rx="1" fill="rgba(255,255,255,0.06)" />
        <rect x="9" y="119" width="18" height="2.5" rx="1" fill="rgba(255,255,255,0.04)" />

        <!-- Column 2 frame (mid level, +16) -->
        <rect x="73" y="19" width="56" height="135" rx="4" fill="rgba(255,255,255,0.06)" stroke="rgba(168,85,247,0.3)" stroke-width="1" />
        <rect x="73" y="19" width="56" height="16" rx="4" fill="rgba(249,115,22,0.1)" />
        <rect x="79" y="25" width="22" height="3" rx="1.5" fill="rgba(249,115,22,0.5)" />

        <!-- Col 2 neutral rows (+16) -->
        <rect x="79" y="45" width="12" height="2.5" rx="1" fill="rgba(255,255,255,0.06)" />
        <circle cx="96" cy="46" r="2" fill="none" stroke="rgba(99,102,241,0.2)" stroke-width="0.6" />
        <rect x="79" y="60" width="16" height="2.5" rx="1" fill="rgba(255,255,255,0.06)" />
        <rect x="98" y="60" width="8" height="2.5" rx="1" fill="rgba(99,102,241,0.15)" />
        <rect x="79" y="75" width="10" height="2.5" rx="1" fill="rgba(255,255,255,0.06)" />
        <circle cx="94" cy="76" r="2" fill="none" stroke="rgba(99,102,241,0.2)" stroke-width="0.6" />
        <rect x="79" y="90" width="14" height="2.5" rx="1" fill="rgba(255,255,255,0.06)" />
        <rect x="79" y="105" width="8" height="2.5" rx="1" fill="rgba(255,255,255,0.06)" />
        <rect x="79" y="120" width="12" height="2.5" rx="1" fill="rgba(255,255,255,0.06)" />

        <!-- Column 3 frame (deep level, +32) -->
        <rect x="139" y="35" width="58" height="135" rx="4" fill="rgba(255,255,255,0.06)" stroke="rgba(168,85,247,0.3)" stroke-width="1" />
        <rect x="139" y="35" width="58" height="16" rx="4" fill="rgba(168,85,247,0.1)" />
        <rect x="145" y="41" width="26" height="3" rx="1.5" fill="rgba(168,85,247,0.45)" />

        <!-- Col 3 neutral rows (+32) -->
        <rect x="145" y="61" width="10" height="2.5" rx="1" fill="rgba(255,255,255,0.06)" />
        <rect x="158" y="61" width="18" height="2.5" rx="1" fill="rgba(255,255,255,0.07)" />
        <rect x="145" y="76" width="8" height="2.5" rx="1" fill="rgba(255,255,255,0.06)" />
        <rect x="156" y="76" width="22" height="2.5" rx="1" fill="rgba(255,255,255,0.07)" />
        <rect x="145" y="91" width="12" height="2.5" rx="1" fill="rgba(255,255,255,0.06)" />
        <rect x="160" y="91" width="14" height="2.5" rx="1" fill="rgba(255,255,255,0.07)" />
        <rect x="145" y="106" width="6" height="2.5" rx="1" fill="rgba(255,255,255,0.06)" />
        <rect x="154" y="106" width="20" height="2.5" rx="1" fill="rgba(255,255,255,0.07)" />
        <rect x="145" y="121" width="10" height="2.5" rx="1" fill="rgba(255,255,255,0.07)" />
        <rect x="158" y="121" width="16" height="2.5" rx="1" fill="rgba(255,255,255,0.05)" />

        <!-- ═══ STATE A: Col1-R2 → Col2-R2 → Col3-R1 ═══ -->
        <g class="atlas-state-a">
          <!-- Col1 Row2 highlight -->
          <rect x="5" y="39" width="56" height="13" rx="2" fill="rgba(168,85,247,0.15)" stroke="rgba(168,85,247,0.35)" stroke-width="0.5" />
          <rect x="9" y="44" width="18" height="2.5" rx="1" fill="rgba(168,85,247,0.6)" />
          <rect x="30" y="44" width="10" height="2.5" rx="1" fill="rgba(249,115,22,0.4)" />
          <path d="M53 45 L57 45" stroke="rgba(168,85,247,0.5)" stroke-width="1" stroke-linecap="round" />
          <!-- Col2 Row2 highlight (+16) -->
          <rect x="75" y="55" width="52" height="13" rx="2" fill="rgba(249,115,22,0.12)" stroke="rgba(249,115,22,0.3)" stroke-width="0.5" />
          <rect x="79" y="60" width="16" height="2.5" rx="1" fill="rgba(249,115,22,0.6)" />
          <rect x="98" y="60" width="8" height="2.5" rx="1" fill="rgba(168,85,247,0.3)" />
          <path d="M119 61 L123 61" stroke="rgba(249,115,22,0.5)" stroke-width="1" stroke-linecap="round" />
          <!-- Col3 Row1 highlight (+32) -->
          <rect x="141" y="56" width="54" height="13" rx="2" fill="rgba(168,85,247,0.1)" stroke="rgba(168,85,247,0.25)" stroke-width="0.5" />
          <rect x="145" y="61" width="10" height="2.5" rx="1" fill="rgba(168,85,247,0.5)" />
          <rect x="158" y="61" width="18" height="2.5" rx="1" fill="rgba(255,255,255,0.2)" />
          <!-- Connections -->
          <path d="M63 45 C69 45, 69 61, 73 61" stroke="rgba(168,85,247,0.4)" stroke-width="1" fill="none" />
          <path d="M129 61 C134 61, 134 62, 139 62" stroke="rgba(249,115,22,0.4)" stroke-width="1" fill="none" />
          <!-- Breadcrumb -->
          <rect x="145" y="140" width="46" height="8" rx="2" fill="rgba(255,255,255,0.03)" stroke="rgba(255,255,255,0.06)" stroke-width="0.5" />
          <circle cx="150" cy="144" r="1.5" fill="rgba(168,85,247,0.4)" />
          <path d="M154 144 L157 144" stroke="rgba(255,255,255,0.12)" stroke-width="0.5" />
          <circle cx="161" cy="144" r="1.5" fill="rgba(249,115,22,0.4)" />
          <path d="M165 144 L168 144" stroke="rgba(255,255,255,0.12)" stroke-width="0.5" />
          <circle cx="172" cy="144" r="1.5" fill="rgba(168,85,247,0.3)" />
        </g>

        <!-- ═══ STATE B: Col1-R4 → Col2-R1 → Col3-R3 ═══ -->
        <g class="atlas-state-b" style="opacity:0">
          <!-- Col1 Row4 highlight -->
          <rect x="5" y="69" width="56" height="13" rx="2" fill="rgba(168,85,247,0.15)" stroke="rgba(168,85,247,0.35)" stroke-width="0.5" />
          <rect x="9" y="74" width="12" height="2.5" rx="1" fill="rgba(168,85,247,0.6)" />
          <rect x="24" y="74" width="10" height="2.5" rx="1" fill="rgba(249,115,22,0.4)" />
          <path d="M53 75 L57 75" stroke="rgba(168,85,247,0.5)" stroke-width="1" stroke-linecap="round" />
          <!-- Col2 Row1 highlight (+16) -->
          <rect x="75" y="40" width="52" height="13" rx="2" fill="rgba(249,115,22,0.12)" stroke="rgba(249,115,22,0.3)" stroke-width="0.5" />
          <rect x="79" y="45" width="12" height="2.5" rx="1" fill="rgba(249,115,22,0.6)" />
          <circle cx="96" cy="46" r="2" fill="none" stroke="rgba(249,115,22,0.4)" stroke-width="0.8" />
          <path d="M119 46 L123 46" stroke="rgba(249,115,22,0.5)" stroke-width="1" stroke-linecap="round" />
          <!-- Col3 Row3 highlight (+32) -->
          <rect x="141" y="86" width="54" height="13" rx="2" fill="rgba(168,85,247,0.1)" stroke="rgba(168,85,247,0.25)" stroke-width="0.5" />
          <rect x="145" y="91" width="12" height="2.5" rx="1" fill="rgba(168,85,247,0.5)" />
          <rect x="160" y="91" width="14" height="2.5" rx="1" fill="rgba(255,255,255,0.2)" />
          <!-- Connections -->
          <path d="M63 75 C69 75, 69 46, 73 46" stroke="rgba(168,85,247,0.4)" stroke-width="1" fill="none" />
          <path d="M129 46 C134 46, 134 92, 139 92" stroke="rgba(249,115,22,0.4)" stroke-width="1" fill="none" />
          <!-- Breadcrumb -->
          <rect x="145" y="140" width="46" height="8" rx="2" fill="rgba(255,255,255,0.03)" stroke="rgba(255,255,255,0.06)" stroke-width="0.5" />
          <circle cx="150" cy="144" r="1.5" fill="rgba(168,85,247,0.4)" />
          <path d="M154 144 L157 144" stroke="rgba(255,255,255,0.12)" stroke-width="0.5" />
          <circle cx="161" cy="144" r="1.5" fill="rgba(249,115,22,0.4)" />
          <path d="M165 144 L168 144" stroke="rgba(255,255,255,0.12)" stroke-width="0.5" />
          <circle cx="172" cy="144" r="1.5" fill="rgba(168,85,247,0.3)" />
        </g>

        <!-- ═══ STATE C: Col1-R4 → Col2-R3 → Col3-R4 ═══ -->
        <g class="atlas-state-c" style="opacity:0">
          <!-- Col1 Row4 still selected -->
          <rect x="5" y="69" width="56" height="13" rx="2" fill="rgba(168,85,247,0.15)" stroke="rgba(168,85,247,0.35)" stroke-width="0.5" />
          <rect x="9" y="74" width="12" height="2.5" rx="1" fill="rgba(168,85,247,0.6)" />
          <rect x="24" y="74" width="10" height="2.5" rx="1" fill="rgba(249,115,22,0.4)" />
          <path d="M53 75 L57 75" stroke="rgba(168,85,247,0.5)" stroke-width="1" stroke-linecap="round" />
          <!-- Col2 Row3 highlight (+16) -->
          <rect x="75" y="70" width="52" height="13" rx="2" fill="rgba(249,115,22,0.12)" stroke="rgba(249,115,22,0.3)" stroke-width="0.5" />
          <rect x="79" y="75" width="10" height="2.5" rx="1" fill="rgba(249,115,22,0.6)" />
          <circle cx="94" cy="76" r="2" fill="none" stroke="rgba(249,115,22,0.4)" stroke-width="0.8" />
          <path d="M119 76 L123 76" stroke="rgba(249,115,22,0.5)" stroke-width="1" stroke-linecap="round" />
          <!-- Col3 Row4 highlight (+32) -->
          <rect x="141" y="101" width="54" height="13" rx="2" fill="rgba(168,85,247,0.1)" stroke="rgba(168,85,247,0.25)" stroke-width="0.5" />
          <rect x="145" y="106" width="6" height="2.5" rx="1" fill="rgba(168,85,247,0.5)" />
          <rect x="154" y="106" width="20" height="2.5" rx="1" fill="rgba(255,255,255,0.2)" />
          <!-- Connections -->
          <path d="M63 75 C69 75, 69 76, 73 76" stroke="rgba(168,85,247,0.4)" stroke-width="1" fill="none" />
          <path d="M129 76 C134 76, 134 107, 139 107" stroke="rgba(249,115,22,0.4)" stroke-width="1" fill="none" />
          <!-- Breadcrumb -->
          <rect x="145" y="140" width="46" height="8" rx="2" fill="rgba(255,255,255,0.03)" stroke="rgba(255,255,255,0.06)" stroke-width="0.5" />
          <circle cx="150" cy="144" r="1.5" fill="rgba(168,85,247,0.4)" />
          <path d="M154 144 L157 144" stroke="rgba(255,255,255,0.12)" stroke-width="0.5" />
          <circle cx="161" cy="144" r="1.5" fill="rgba(249,115,22,0.4)" />
          <path d="M165 144 L168 144" stroke="rgba(255,255,255,0.12)" stroke-width="0.5" />
          <rect x="169" y="142" width="12" height="4" rx="1" fill="rgba(168,85,247,0.15)" stroke="rgba(168,85,247,0.25)" stroke-width="0.5" />
        </g>

        <!-- ═══ CLICK RIPPLES ═══ -->
        <circle cx="39" cy="45" r="8" fill="none" stroke="rgba(168,85,247,0.5)" stroke-width="1" class="atlas-ripple-a" />
        <circle cx="32" cy="75" r="8" fill="none" stroke="rgba(168,85,247,0.5)" stroke-width="1" class="atlas-ripple-b" />
        <circle cx="97" cy="76" r="8" fill="none" stroke="rgba(249,115,22,0.5)" stroke-width="1" class="atlas-ripple-c" />

        <!-- ═══ HAND CURSOR ═══ -->
        <g class="atlas-cursor">
          <!-- Index finger -->
          <rect x="1.5" y="0" width="4" height="7.5" rx="2" fill="rgba(255,255,255,0.9)" stroke="rgba(0,0,0,0.25)" stroke-width="0.4" />
          <!-- Palm -->
          <rect x="0" y="6" width="9.5" height="7" rx="2.5" fill="rgba(255,255,255,0.9)" stroke="rgba(0,0,0,0.25)" stroke-width="0.4" />
          <!-- Thumb -->
          <ellipse cx="-0.5" cy="8" rx="2" ry="1.2" transform="rotate(-35, -0.5, 8)" fill="rgba(255,255,255,0.85)" stroke="rgba(0,0,0,0.2)" stroke-width="0.3" />
          <!-- Knuckle lines -->
          <line x1="3" y1="7" x2="7" y2="7" stroke="rgba(0,0,0,0.1)" stroke-width="0.3" stroke-linecap="round" />
          <line x1="2" y1="9.5" x2="8" y2="9.5" stroke="rgba(0,0,0,0.06)" stroke-width="0.3" stroke-linecap="round" />
        </g>

        </g>

      </svg>
    </div>

    <!-- Chill — bottom-right: empty desk setup, owner gone -->
    <div class="feature-container feature-container-4 absolute bottom-[8%] right-[5%]">
      <svg width="320" height="280" viewBox="0 0 240 210" fill="none" xmlns="http://www.w3.org/2000/svg">

        <!-- ═══ DESK ═══ -->
        <rect x="55" y="120" width="175" height="6" rx="2.5" fill="rgba(255,255,255,0.07)" stroke="rgba(255,255,255,0.14)" stroke-width="1" />
        <!-- Left leg panel -->
        <rect x="62" y="126" width="4" height="60" rx="1.5" fill="rgba(255,255,255,0.05)" stroke="rgba(255,255,255,0.1)" stroke-width="0.8" />
        <rect x="58" y="180" width="12" height="3" rx="1" fill="rgba(255,255,255,0.06)" />
        <!-- Right leg panel -->
        <rect x="218" y="126" width="4" height="60" rx="1.5" fill="rgba(255,255,255,0.05)" stroke="rgba(255,255,255,0.1)" stroke-width="0.8" />
        <rect x="214" y="180" width="12" height="3" rx="1" fill="rgba(255,255,255,0.06)" />
        <!-- Crossbar -->
        <rect x="66" y="160" width="156" height="2" rx="1" fill="rgba(255,255,255,0.03)" />

        <!-- ═══ MONITOR ═══ -->
        <!-- Stand base -->
        <rect x="140" y="108" width="30" height="4" rx="2" fill="rgba(255,255,255,0.06)" stroke="rgba(255,255,255,0.1)" stroke-width="0.6" />
        <!-- Stand neck -->
        <rect x="152" y="98" width="6" height="14" rx="1.5" fill="rgba(255,255,255,0.05)" stroke="rgba(255,255,255,0.08)" stroke-width="0.5" />
        <!-- Monitor frame -->
        <rect x="118" y="42" width="74" height="56" rx="4" fill="rgba(255,255,255,0.06)" stroke="rgba(255,255,255,0.16)" stroke-width="1.2" />
        <!-- Screen -->
        <rect x="122" y="46" width="66" height="44" rx="2.5" fill="rgba(15,23,42,0.6)" stroke="rgba(99,102,241,0.12)" stroke-width="0.5" />
        <!-- Screen content — code running autonomously -->
        <rect x="128" y="52" width="28" height="2.5" rx="1" fill="rgba(168,85,247,0.35)" />
        <rect x="160" y="52" width="14" height="2.5" rx="1" fill="rgba(249,115,22,0.25)" />
        <rect x="128" y="59" width="18" height="2.5" rx="1" fill="rgba(249,115,22,0.3)" />
        <rect x="150" y="59" width="22" height="2.5" rx="1" fill="rgba(255,255,255,0.1)" />
        <rect x="134" y="66" width="30" height="2.5" rx="1" fill="rgba(255,255,255,0.08)" />
        <rect x="168" y="66" width="12" height="2.5" rx="1" fill="rgba(168,85,247,0.2)" />
        <rect x="134" y="73" width="14" height="2.5" rx="1" fill="rgba(168,85,247,0.25)" />
        <rect x="152" y="73" width="20" height="2.5" rx="1" fill="rgba(249,115,22,0.2)" />
        <rect x="128" y="80" width="8" height="2.5" rx="1" fill="rgba(255,255,255,0.06)" />
        <!-- Blinking cursor -->
        <rect x="140" y="80" width="1.5" height="8" rx="0.5" fill="rgba(255,255,255,0.5)" class="chill-cursor" />
        <!-- Screen glow overlay -->
        <rect x="122" y="46" width="66" height="44" rx="2.5" fill="none" stroke="rgba(99,102,241,0.2)" stroke-width="0.8" class="chill-screen-glow" />
        <!-- Webcam -->
        <circle cx="155" cy="44" r="1.5" fill="rgba(34,197,94,0.5)" class="chill-notif" />
        <!-- Monitor chin -->
        <rect x="145" y="90" width="20" height="5" rx="1" fill="rgba(255,255,255,0.03)" />

        <!-- ═══ KEYBOARD + MOUSE ═══ -->
        <rect x="135" y="113" width="44" height="7" rx="2.5" fill="rgba(255,255,255,0.05)" stroke="rgba(255,255,255,0.1)" stroke-width="0.7" />
        <!-- Key rows -->
        <rect x="138" y="115" width="5" height="2" rx="0.5" fill="rgba(255,255,255,0.06)" />
        <rect x="145" y="115" width="5" height="2" rx="0.5" fill="rgba(255,255,255,0.06)" />
        <rect x="152" y="115" width="5" height="2" rx="0.5" fill="rgba(255,255,255,0.06)" />
        <rect x="159" y="115" width="5" height="2" rx="0.5" fill="rgba(255,255,255,0.06)" />
        <rect x="166" y="115" width="5" height="2" rx="0.5" fill="rgba(255,255,255,0.06)" />
        <rect x="173" y="115" width="3" height="2" rx="0.5" fill="rgba(255,255,255,0.04)" />
        <!-- Mouse -->
        <rect x="186" y="114" width="10" height="6" rx="3" fill="rgba(255,255,255,0.04)" stroke="rgba(255,255,255,0.1)" stroke-width="0.6" />
        <line x1="191" y1="114" x2="191" y2="117" stroke="rgba(255,255,255,0.06)" stroke-width="0.4" />

        <!-- ═══ COFFEE MUG (right side of desk) ═══ -->
        <path d="M200 107 L200 118 Q200 122 204 122 L214 122 Q218 122 218 118 L218 107 Z" fill="rgba(249,115,22,0.1)" stroke="rgba(249,115,22,0.3)" stroke-width="1" />
        <path d="M218 110 Q224 110 224 114 Q224 119 218 119" stroke="rgba(249,115,22,0.25)" stroke-width="1" fill="none" />
        <ellipse cx="209" cy="109" rx="8" ry="2" fill="rgba(139,69,19,0.15)" />
        <!-- Steam -->
        <path d="M205 104 Q206 97 203 90" stroke="rgba(255,255,255,0.3)" stroke-width="1.2" fill="none" stroke-linecap="round" class="chill-steam" />
        <path d="M210 105 Q211 97 208 89" stroke="rgba(255,255,255,0.25)" stroke-width="1.2" fill="none" stroke-linecap="round" class="chill-steam" style="animation-delay: 1.2s;" />
        <path d="M215 104 Q216 97 213 90" stroke="rgba(255,255,255,0.2)" stroke-width="1" fill="none" stroke-linecap="round" class="chill-steam" style="animation-delay: 2.4s;" />

        <!-- ═══ OFFICE CHAIR (simple, iconic — drifts gently) ═══ -->
        <g class="chill-chair">
        <rect x="12" y="56" width="26" height="52" rx="6" fill="rgba(255,255,255,0.06)" stroke="rgba(255,255,255,0.16)" stroke-width="1.2" />
        <rect x="6" y="110" width="52" height="10" rx="4" fill="rgba(255,255,255,0.07)" stroke="rgba(255,255,255,0.16)" stroke-width="1.2" />
        <rect x="2" y="98" width="10" height="4" rx="2" fill="rgba(255,255,255,0.06)" stroke="rgba(255,255,255,0.12)" stroke-width="0.8" />
        <rect x="52" y="98" width="10" height="4" rx="2" fill="rgba(255,255,255,0.06)" stroke="rgba(255,255,255,0.12)" stroke-width="0.8" />
        <rect x="29" y="120" width="6" height="24" rx="3" fill="rgba(255,255,255,0.06)" stroke="rgba(255,255,255,0.1)" stroke-width="0.8" />
        <line x1="32" y1="144" x2="10" y2="158" stroke="rgba(255,255,255,0.12)" stroke-width="2.5" stroke-linecap="round" />
        <line x1="32" y1="144" x2="54" y2="158" stroke="rgba(255,255,255,0.12)" stroke-width="2.5" stroke-linecap="round" />
        <circle cx="10" cy="160" r="3.5" fill="rgba(255,255,255,0.05)" stroke="rgba(255,255,255,0.12)" stroke-width="1" />
        <circle cx="54" cy="160" r="3.5" fill="rgba(255,255,255,0.05)" stroke="rgba(255,255,255,0.12)" stroke-width="1" />
        </g>

        <!-- ═══ BACKPACK on floor ═══ -->
        <g transform="translate(68, 140)">
          <!-- Bag body -->
          <rect x="0" y="8" width="22" height="28" rx="4" fill="rgba(168,85,247,0.1)" stroke="rgba(168,85,247,0.28)" stroke-width="1" />
          <!-- Top flap -->
          <path d="M0 14 Q0 8 4 8 L18 8 Q22 8 22 14" fill="rgba(168,85,247,0.08)" stroke="rgba(168,85,247,0.25)" stroke-width="0.8" />
          <!-- Handle loop -->
          <path d="M7 8 Q7 2 11 2 Q15 2 15 8" stroke="rgba(168,85,247,0.3)" stroke-width="1.2" fill="none" stroke-linecap="round" />
          <!-- Front pocket -->
          <rect x="4" y="20" width="14" height="10" rx="2" fill="rgba(168,85,247,0.06)" stroke="rgba(168,85,247,0.18)" stroke-width="0.7" />
          <!-- Zipper line -->
          <line x1="11" y1="8" x2="11" y2="14" stroke="rgba(168,85,247,0.2)" stroke-width="0.6" stroke-linecap="round" />
          <!-- Zipper pull -->
          <circle cx="11" cy="14" r="1" fill="rgba(168,85,247,0.3)" />
          <!-- Strap hanging down -->
          <path d="M3 36 Q2 42 5 44" stroke="rgba(168,85,247,0.2)" stroke-width="1.2" fill="none" stroke-linecap="round" />
        </g>

        <!-- ═══ PHONE on stand ═══ -->
        <!-- Stand base -->
        <ellipse cx="88" cy="120" rx="10" ry="3" fill="rgba(255,255,255,0.04)" stroke="rgba(255,255,255,0.1)" stroke-width="0.7" />
        <!-- Stand arm -->
        <rect x="86" y="108" width="4" height="12" rx="1.5" fill="rgba(255,255,255,0.05)" stroke="rgba(255,255,255,0.1)" stroke-width="0.6" />
        <!-- Stand lip/cradle -->
        <path d="M82 108 L94 108 L94 110 L82 110 Z" rx="1" fill="rgba(255,255,255,0.05)" stroke="rgba(255,255,255,0.08)" stroke-width="0.5" />
        <!-- Phone body (upright, leaning on stand) -->
        <rect x="79" y="78" width="18" height="30" rx="3" fill="rgba(255,255,255,0.05)" stroke="rgba(255,255,255,0.14)" stroke-width="0.8" />
        <!-- Phone screen -->
        <rect x="81" y="82" width="14" height="22" rx="1.5" fill="rgba(15,23,42,0.5)" stroke="rgba(99,102,241,0.1)" stroke-width="0.4" />
        <!-- Notifications sliding in -->
        <g class="chill-phone-notif">
          <rect x="83" y="86" width="10" height="3" rx="1" fill="rgba(249,115,22,0.25)" />
          <rect x="83" y="91" width="7" height="2" rx="1" fill="rgba(255,255,255,0.08)" />
        </g>
        <g class="chill-phone-notif-2">
          <rect x="83" y="95" width="10" height="3" rx="1" fill="rgba(168,85,247,0.2)" />
          <rect x="83" y="100" width="5" height="2" rx="1" fill="rgba(255,255,255,0.06)" />
        </g>
        <!-- Notch -->
        <rect x="85" y="80" width="6" height="2" rx="1" fill="rgba(255,255,255,0.03)" />
        <!-- Notification badge -->
        <circle cx="95" cy="80" r="2" fill="rgba(249,115,22,0.5)" class="chill-notif" />

        <!-- ═══ FLOATING Z's above empty chair ═══ -->
        <text x="36" y="42" font-size="14" font-weight="bold" fill="rgba(168,85,247,0.55)" font-family="system-ui" class="chill-z1">z</text>
        <text x="50" y="28" font-size="11" font-weight="bold" fill="rgba(168,85,247,0.4)" font-family="system-ui" class="chill-z2">z</text>
        <text x="62" y="18" font-size="9" font-weight="bold" fill="rgba(168,85,247,0.3)" font-family="system-ui" class="chill-z3">z</text>

      </svg>
      <p class="text-lg mt-1 tracking-widest uppercase font-semibold title-cycle text-center whitespace-nowrap">You envision. Zavo engineers.</p>
    </div>
  </div>

  <!-- Centered panel -->
  <div class="relative w-full max-w-lg flex flex-col max-h-full animate-fadeIn">

    <!-- Brand mark — two SVGs cross-fading -->
    <div class="flex items-center justify-center mb-4 sm:mb-8 relative shrink-0" style="height:32px; width:66px; margin-left:auto; margin-right:auto;">
      <svg viewBox="0 0 66 43" class="h-8 w-auto badge-purple absolute inset-0" xmlns="http://www.w3.org/2000/svg">
        <path d="M65.07 19.296a3.074 3.074 0 0 1 0 4.414l-3.8 3.74-3.599 3.536-11.999 11.808a.636.636 0 0 1-.456.187H15.947a.64.64 0 0 1-.603-.386.614.614 0 0 1 .154-.692l4.726-4.651 2.534-2.494a.633.633 0 0 1 .456-.187h18.372a.642.642 0 0 0 .456-.187l3.427-3.373 7.419-7.295a3.074 3.074 0 0 0 0-4.414L42.105 8.63a.634.634 0 0 0-.456-.187h-8.635a.64.64 0 0 1-.603-.387.614.614 0 0 1 .154-.692l4.13-4.059L39.863.187A.634.634 0 0 1 40.319 0h4.884a.643.643 0 0 1 .456.187l19.411 19.11Z" fill="url(#grad-purple)" />
        <path d="m34.812 1.117-7.248 7.132a.67.67 0 0 1-.468.194h-6.209a.642.642 0 0 0-.468.17.624.624 0 0 0-.197.453v23.878c0 .174-.072.34-.197.462l-.424.418-6.823 6.714a.634.634 0 0 1-.749.202.63.63 0 0 1-.308-.267.615.615 0 0 1-.077-.396V9.097a.615.615 0 0 0-.197-.452.636.636 0 0 0-.468-.171H.665a.643.643 0 0 1-.468-.172A.623.623 0 0 1 0 7.85V.655A.615.615 0 0 1 .197.203.635.635 0 0 1 .665.032h33.697a.641.641 0 0 1 .61.387.614.614 0 0 1-.16.698Z" fill="url(#grad-purple)" />
        <defs>
          <linearGradient id="grad-purple" x1="0" y1="0" x2="66" y2="43" gradientUnits="userSpaceOnUse">
            <stop stop-color="#c4b5fd" /><stop offset="0.5" stop-color="#a855f7" /><stop offset="1" stop-color="#7c3aed" />
          </linearGradient>
        </defs>
      </svg>
      <svg viewBox="0 0 66 43" class="h-8 w-auto badge-orange" xmlns="http://www.w3.org/2000/svg">
        <path d="M65.07 19.296a3.074 3.074 0 0 1 0 4.414l-3.8 3.74-3.599 3.536-11.999 11.808a.636.636 0 0 1-.456.187H15.947a.64.64 0 0 1-.603-.386.614.614 0 0 1 .154-.692l4.726-4.651 2.534-2.494a.633.633 0 0 1 .456-.187h18.372a.642.642 0 0 0 .456-.187l3.427-3.373 7.419-7.295a3.074 3.074 0 0 0 0-4.414L42.105 8.63a.634.634 0 0 0-.456-.187h-8.635a.64.64 0 0 1-.603-.387.614.614 0 0 1 .154-.692l4.13-4.059L39.863.187A.634.634 0 0 1 40.319 0h4.884a.643.643 0 0 1 .456.187l19.411 19.11Z" fill="url(#grad-orange)" />
        <path d="m34.812 1.117-7.248 7.132a.67.67 0 0 1-.468.194h-6.209a.642.642 0 0 0-.468.17.624.624 0 0 0-.197.453v23.878c0 .174-.072.34-.197.462l-.424.418-6.823 6.714a.634.634 0 0 1-.749.202.63.63 0 0 1-.308-.267.615.615 0 0 1-.077-.396V9.097a.615.615 0 0 0-.197-.452.636.636 0 0 0-.468-.171H.665a.643.643 0 0 1-.468-.172A.623.623 0 0 1 0 7.85V.655A.615.615 0 0 1 .197.203.635.635 0 0 1 .665.032h33.697a.641.641 0 0 1 .61.387.614.614 0 0 1-.16.698Z" fill="url(#grad-orange)" />
        <defs>
          <linearGradient id="grad-orange" x1="0" y1="0" x2="66" y2="43" gradientUnits="userSpaceOnUse">
            <stop stop-color="#fde68a" /><stop offset="0.5" stop-color="#f97316" /><stop offset="1" stop-color="#dc2626" />
          </linearGradient>
        </defs>
      </svg>
    </div>

    <!-- Header -->
    <div class="text-center mb-4 sm:mb-6 shrink-0">
      <h1 class="text-xl font-semibold title-cycle tracking-tight">Select a project</h1>
      <p class="text-sm text-gray-400 mt-1">What are we building today?</p>
      <!-- NOT on a project row: clicking a row selects that client and navigates away, and chart
           style is a BUILDER preference that is not scoped to a project at all. -->
      <button id="open-chart-style" (click)="openChartStyle()"
              class="mt-3 inline-flex items-center gap-1.5 px-3 py-1.5 text-xs rounded-lg border border-gray-700/60 text-gray-400 hover:text-gray-200 hover:border-gray-600 transition-colors">
        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2"
             stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/>
          <line x1="6" y1="20" x2="6" y2="14"/>
        </svg>
        Chart style
      </button>
      <button *ngIf="canConnectClaude" data-test="projects-connect-claude" (click)="openConnectClaude()"
              class="mt-3 ml-2 inline-flex items-center gap-1.5 px-3 py-1.5 text-xs rounded-lg border border-gray-700/60 text-gray-400 hover:text-gray-200 hover:border-gray-600 transition-colors">
        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2"
             stroke-linecap="round" stroke-linejoin="round">
          <path d="M9 2v6"></path><path d="M15 2v6"></path><path d="M6 8h12v3a6 6 0 0 1-12 0V8z"></path><path d="M12 17v5"></path>
        </svg>
        Connect Claude
      </button>
    </div>

    <!-- Main card -->
    <div class="bg-gray-800/80 backdrop-blur-xl rounded-2xl border border-gray-700/60 shadow-2xl shadow-black/40 overflow-hidden">

      <!-- Search -->
      <div class="p-3 border-b border-gray-700/50">
        <div class="relative">
          <svg class="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500 pointer-events-none" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
          </svg>
          <input
            type="text"
            class="w-full rounded-lg bg-gray-900/60 border border-gray-700/50 pl-9 pr-9 py-2.5 text-sm text-gray-200 placeholder-gray-500 focus:outline-none focus:bg-gray-900/80 focus:border-orange-500/40 focus:ring-1 focus:ring-orange-500/20 transition-all duration-200"
            placeholder="Search projects..."
            [(ngModel)]="searchTerm"
            (input)="filterClients()"
          />
          <button
            *ngIf="searchTerm"
            class="absolute right-2.5 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-300 cursor-pointer transition-colors"
            (click)="searchTerm = ''; filterClients()">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>

      <!-- Project list -->
      <div class="max-h-[min(400px,calc(100dvh_-_290px))] overflow-y-auto dark-scroll">
        <div *ngIf="filteredClients.length > 0; else emptyState">
          <div
            *ngFor="let client of filteredClients; let i = index"
            class="group flex items-center gap-3 px-4 py-3 cursor-pointer transition-all duration-150"
            [ngClass]="client[2] === clientService.selectedClientId
              ? 'bg-orange-500/10'
              : 'hover:bg-white/[0.03]'"
            (click)="selectClientFromList(client[2]); selectedClient()">

            <!-- Identicon -->
            <div
              class="h-9 w-9 rounded-lg shrink-0 transition-colors p-[5px] grid grid-cols-4 grid-rows-4 gap-[2px]"
              [ngClass]="client[2] === clientService.selectedClientId
                ? 'bg-gray-800/80 ring-1 ring-orange-500/30'
                : 'bg-gray-800/50'">
              <div *ngFor="let cell of getIdenticon(client[1])"
                   class="rounded-[1px]"
                   [ngClass]="{
                     'bg-white/12': cell === 'white' && client[2] !== clientService.selectedClientId,
                     'bg-white/25': cell === 'white' && client[2] === clientService.selectedClientId,
                     'bg-orange-500/30': cell === 'orange' && client[2] !== clientService.selectedClientId,
                     'bg-orange-500/50': cell === 'orange' && client[2] === clientService.selectedClientId,
                     'bg-purple-500/25': cell === 'purple' && client[2] !== clientService.selectedClientId,
                     'bg-purple-500/40': cell === 'purple' && client[2] === clientService.selectedClientId,
                     'bg-transparent': cell === 'off'
                   }">
              </div>
            </div>

            <!-- Info -->
            <div class="min-w-0 flex-1">
              <p class="text-sm font-medium text-gray-200 truncate">{{ client[1] }}</p>
              <p class="text-[11px] text-gray-500 font-mono truncate">{{ client[2] }}</p>
              <p *ngIf="developerModeByProject.get(client[0]) as label"
                 class="text-[10px] font-medium text-purple-300 truncate">{{ label }}</p>
            </div>

            <!-- Actions (hidden for now) -->
            <!-- <div class="flex items-center gap-1.5 shrink-0">
              <button
                *ngIf="canMigrateToProd(client[2])"
                class="opacity-0 group-hover:opacity-100 inline-flex items-center justify-center h-7 px-2 text-[10px] font-medium rounded-md bg-emerald-500/15 text-emerald-400 border border-emerald-500/20 hover:bg-emerald-500/25 transition-all duration-150 cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed"
                [disabled]="migrationLoadingStates[client[2]]"
                (click)="migrateToProd(client[2]); $event.stopPropagation()">
                <svg
                  *ngIf="migrationLoadingStates[client[2]]"
                  class="animate-spin h-3 w-3"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="m4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                <svg
                  *ngIf="!migrationLoadingStates[client[2]]"
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-3 w-3"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M7 11l5-5m0 0l5 5m-5-5v12" />
                </svg>
                <span class="ml-1">{{ migrationLoadingStates[client[2]] ? 'Migrating' : 'Prod' }}</span>
              </button>
            </div> -->
          </div>
        </div>

        <!-- Empty state — loading, a failed load, or truly no projects. A failed load must never read as
             "No projects yet": that tells a builder their projects are gone (zavo_oct_04). -->
        <ng-template #emptyState>
          <div *ngIf="projectsLoading" class="flex flex-col items-center justify-center py-12 px-4 text-center">
            <svg class="animate-spin h-6 w-6 text-gray-500 mb-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="m4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <p class="text-sm font-medium text-gray-300">Loading your projects…</p>
          </div>
          <div *ngIf="!projectsLoading && projectsLoadError" class="flex flex-col items-center justify-center py-12 px-4 text-center">
            <div class="h-12 w-12 rounded-xl bg-red-500/10 flex items-center justify-center mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
              </svg>
            </div>
            <p class="text-sm font-medium text-gray-300 mb-1">
              {{ projectsLoadError === 'network' ? "Can't reach Zavo" : projectsLoadError === 'auth' ? 'Your session has ended' : "Couldn't load your projects" }}
            </p>
            <p class="text-xs text-gray-500 max-w-xs mb-4">
              {{ projectsLoadError === 'network'
                ? 'Check your internet connection. Your projects are safe. We will try again as soon as you are back online.'
                : projectsLoadError === 'auth'
                  ? 'Sign out and sign in again to see your projects.'
                  : 'Your projects are safe. Something went wrong on our side. Try again in a moment.' }}
            </p>
            <button
              *ngIf="projectsLoadError !== 'auth'"
              (click)="loadMyProjects()"
              class="text-xs font-medium text-orange-400 hover:text-orange-300 cursor-pointer transition-colors">
              Try again
            </button>
            <button
              *ngIf="projectsLoadError === 'auth'"
              (click)="signOut()"
              class="text-xs font-medium text-orange-400 hover:text-orange-300 cursor-pointer transition-colors">
              Sign out
            </button>
          </div>
          <div *ngIf="!projectsLoading && !projectsLoadError" class="flex flex-col items-center justify-center py-12 px-4 text-center">
            <div class="h-12 w-12 rounded-xl bg-gray-700/40 flex items-center justify-center mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </div>
            <p class="text-sm font-medium text-gray-300 mb-1">{{ searchTerm ? 'No matches' : 'No projects yet' }}</p>
            <p class="text-xs text-gray-500 max-w-xs mb-4">
              {{ searchTerm
                ? 'No projects match your search.'
                : 'Create your first project to get started.' }}
            </p>
            <button
              *ngIf="searchTerm"
              (click)="searchTerm = ''; filterClients()"
              class="text-xs font-medium text-orange-400 hover:text-orange-300 cursor-pointer transition-colors">
              Clear search
            </button>
          </div>
        </ng-template>
      </div>

      <!-- Footer: New Project -->
      <div class="border-t border-gray-700/50 p-3">
        <button
          (click)="createNewClientFlagChange()"
          class="w-full flex items-center justify-center gap-2 py-2.5 text-sm font-medium text-gray-400 rounded-lg hover:bg-orange-500/10 hover:text-orange-300 transition-all duration-150 cursor-pointer">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4" />
          </svg>
          New Project
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Create Project Modal -->
<div
  class="fixed inset-0 z-[60]"
  *ngIf="createNewClientFlag">
  <div class="fixed inset-0 bg-black/60 backdrop-blur-sm" (click)="createNewClientFlagChange()"></div>
  <div class="flex min-h-screen items-center justify-center p-4">
    <div class="relative z-10 w-full max-w-sm bg-gray-900 rounded-2xl border border-gray-700/60 shadow-2xl shadow-black/60 overflow-hidden animate-fadeIn">
      <div class="p-6">
        <div class="flex items-center justify-between mb-5">
          <h2 class="text-base font-semibold text-gray-200">New Project</h2>
          <button
            class="h-7 w-7 rounded-lg hover:bg-gray-800 flex items-center justify-center text-gray-500 hover:text-gray-300 transition-colors cursor-pointer"
            (click)="createNewClientFlagChange()">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div>
          <label for="clientName" class="block text-xs font-medium text-gray-300 mb-1.5">Project Name</label>
          <input
            type="text"
            id="clientName"
            class="w-full rounded-lg bg-gray-800 border border-gray-600 px-3.5 py-2.5 text-sm text-gray-200 placeholder-gray-500 focus:outline-none focus:border-orange-500/50 focus:ring-2 focus:ring-orange-500/20 transition-all duration-200"
            placeholder="Enter project name..."
            [(ngModel)]="newClient.name"
            autocomplete="off"
          />
          <p class="mt-1.5 text-[11px] text-gray-500">Choose a descriptive name for your project</p>
        </div>

        <!-- Info card -->
        <div class="mt-4 bg-gray-800/50 rounded-lg border border-gray-700/50 overflow-hidden">
          <div
            class="px-3 py-2.5 flex items-center justify-between cursor-pointer hover:bg-gray-800 transition-colors"
            (click)="toggleInfoCard()">
            <div class="flex items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5 text-orange-400/60" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span class="text-xs text-gray-400">What happens next?</span>
            </div>
            <svg xmlns="http://www.w3.org/2000/svg"
                 [class.rotate-180]="showInfoDetails"
                 class="h-3.5 w-3.5 text-gray-500 transform transition-transform duration-200"
                 fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
            </svg>
          </div>
          <div *ngIf="showInfoDetails" class="px-3 pb-2.5 pt-0">
            <ul class="space-y-1 text-[11px] text-gray-500">
              <li>Configure project settings</li>
              <li>Manage team members and permissions</li>
              <li>Set up entities and pages</li>
              <li>Configure workflows and integrations</li>
            </ul>
          </div>
        </div>
      </div>

      <div class="px-6 py-4 border-t border-gray-700/50 flex justify-end gap-2">
        <button
          class="px-4 py-2 text-sm font-medium text-gray-400 rounded-lg hover:text-white hover:bg-gray-800 transition-all duration-150 cursor-pointer"
          (click)="createNewClientFlagChange()">
          Cancel
        </button>
        <button
          class="px-4 py-2 text-sm font-medium bg-gradient-to-r from-orange-500 to-red-600 text-white rounded-lg shadow-lg shadow-orange-500/20 hover:from-orange-600 hover:to-red-700 transition-all duration-150 cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed disabled:shadow-none"
          [disabled]="!newClient.name.trim()"
          data-mcp-button="Create"
          (click)="createNewClient()">
          Create
        </button>
      </div>
    </div>
  </div>
</div>
